/* eslint-disable linebreak-style */
/* eslint-disable max-len */
import React, { useState } from 'react';
import Header from '../partial/header';
import Footer from '../partial/footer';
import ParmForm from '../partial/ParmForm';
import HomePopup from './homePopup';
// this is a page called Home, it's nested in the Template route in main.js so will
// inherit the Template layout
const Home = () => {
  const [popupOpen, setPopupOpen] = useState(true);
  return (
    <>
      <Header />
      <section className="features-icons">
        <HomePopup popupOpen={popupOpen} setPopupOpen={setPopupOpen} />
        <div className="container">
          {/* <div className="row">
      <p className="welcome-text" style="text-align: center;">Welcome to the ProActive Registry Management (PARM) Diabetes website, where you can download the PARM Diabetes tool, access the video user guides, and other files relevant to your clinical system.<br />Please fill in the form below to download the latest version of the PARM tool. <br />All fields marked with an asterisk (*) are required for compliance documentation.</b></p>
    </div> */}
          <ParmForm />
        </div>
      </section>
      <Footer />
    </>
  );
};
export default Home;
